import React from 'react'
import { Datagrid, DeleteButton, List, SelectField, TextField } from 'react-admin'
import UserFilter from './UserFilter'
import UserListActions from './UserListActions'

const columnStyles = {
  email: { width: '250px', maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  category: { maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' },
}

const languageChoices = [
  { id: 'en', name: 'main.english' },
  { id: 'nl', name: 'main.dutch' },
  { id: 'fr', name: 'main.french' },
  { id: 'es', name: 'main.spanish' },
  { id: 'da', name: 'main.danish' },
  { id: 'it', name: 'main.italian' },
  { id: 'ro', name: 'main.romanian' },
  { id: 'no', name: 'main.norwegian' },
  { id: 'de', name: 'main.german' },
]

const CategoryField = ({ record = {} }) => {
  const category = record.category
  if (!Array.isArray(category) || category.length === 0) return <span />
  const text = category.map((c) => c.name || '').join(' > ')
  return (
    <span style={columnStyles.category} title={text}>
      {text}
    </span>
  )
}
CategoryField.defaultProps = { label: 'resources.users.fields.category' }

const UserList = (props) => {
  return (
    <List
      {...props}
      sort={{ field: 'email', order: 'ASC' }}
      exporter={false}
      filters={<UserFilter />}
      actions={<UserListActions permissions={props.permissions} />}
    >
      <Datagrid rowClick="edit">
        <TextField source="email" cellClassName="col-email" style={columnStyles.email} />
        <TextField source="connection" sortable={false} />
        <SelectField source="language" choices={languageChoices} sortable={false} />
        <CategoryField style={columnStyles.category} />
        {props.permissions?.includes('delete:users') && <DeleteButton />}
      </Datagrid>
    </List>
  )
}

export default UserList
